export default class File { }
